const phoneIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/phone.png'
const homephoneIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/homephone.png'
const mailIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/email.png'
const wwwIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/www.png'
const placemarkIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/placemark.png'
const skypeIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/skype2.png'

const socialsIcons = [
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/facebook.png',
    link: 'https://www.facebook.com/uaeconsulting/',
    mediaType: 'facebook',
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/vk.png',
    link: '',
    mediaType: 'vkontakte'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/youtube.png',
    link: 'https://www.youtube.com/channel/UCoT9JgJZMMvnIvZM-84LmaQ?sub_confirmation=1',
    mediaType: 'youTube'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/instagram.png',
    link: 'https://www.instagram.com/uaeconsulting/',
    mediaType: 'instagram'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/twitter.png',
    link: 'https://twitter.com/UaeConsulting',
    mediaType: 'twitter'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/telegram.png',
    link: 'https://t.me/uae_consulting',
    mediaType: 'telegram'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/linkedin.png',
    link: 'https://www.linkedin.com/company/uae-consulting-com/',
    mediaType: 'linkedIn'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/rss.png',
    link: 'https://www.uae-consulting.com/rss/',
    mediaType: 'rss'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/igtv.png',
    link: 'https://www.instagram.com/uaeconsulting/',
    mediaType: 'igtv'
  }
]

export {
  phoneIcon,
  homephoneIcon,
  mailIcon,
  wwwIcon,
  placemarkIcon,
  skypeIcon,
  socialsIcons
}



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/svgIconsSignature.js